<script setup>
  import { ref, defineProps, defineEmits } from 'vue'

  defineProps({
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    saveButtonText: {
      type: String,
      default: '登録',
    },
    copyButtonText: {
      type: String,
      default: 'コピー',
    },
    deleteButtonText: {
      type: String,
      default: '削除',
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    showCopyButton: {
      type: Boolean,
      default: true,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    hideAction: {
      type: Boolean,
      default: false,
    },
    disabledSaveButton: {
      type: Boolean,
      default: false,
    },
    disabledCopyButton: {
      type: Boolean,
      default: false,
    },
    disabledDeleteButton: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['update:visible', 'save', 'copy', 'delete', 'close'])

  const onClose = () => {
    emit('update:visible', false)
    emit('close')
  }

  const onSave = () => {
    emit('save')
  }
  const onCopy = () => {
    emit('copy')
  }
  const onDelete = () => {
    emit('delete')
  }
</script>

<template>
  <div class="popup-edit fadein" :class="{ small: small, dark: dark, large: large, medium: medium }" v-if="visible">
    <div class="popup-content">
      <button class="close" type="button" v-if="!hideCloseButton"><span class="material-symbols-outlined" @click="onClose">close</span></button>
      <div class="popup-title">
        <slot name="title"></slot>
        <slot name="select"></slot>
      </div>
      <div class="popup-body scroller">
        <slot name="content"></slot>
      </div>
      <div class="popup-action" v-if="(showSaveButton || showCopyButton || showDeleteButton) && !hideAction">
        <div class="left">
          <button type="button" @click="onDelete" class="input-delete" v-if="showDeleteButton" :disabled="disabledDeleteButton">{{ deleteButtonText }}</button>
          <button type="button" @click="onCopy" class="input-copy" v-if="showCopyButton" :disabled="disabledCopyButton">{{ copyButtonText }}</button>
        </div>
        <div class="right">
          <button type="button" @click="onSave" class="input-save" v-if="showSaveButton" :disabled="disabledSaveButton">{{ saveButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped></style>
